import { Loader } from "../components";
import { useApi } from "../app/ApiContext";
import { usePremFixtures, useGameweekContext } from "../data";
import { PremFixture } from "../models";
import { LiveBadge, OriginHint, PageHeader, PremFixtureRow } from "../ui";
import "./FixturesScreen.css";

const groupFixtures = (fixtures: PremFixture[]) => ({
	live: fixtures.filter((f) => f.live),
	finished: fixtures.filter((f) => f.finished),
	upcoming: fixtures.filter((f) => !f.live && !f.finished),
});

const Section = ({ label, items }: { label: string; items: PremFixture[] }) => {
	if (items.length === 0) {
		return null;
	}
	return (
		<section className="fixture-section">
			<div className="eyebrow fixture-section-heading">
				{label} · <span className="faint">{items.length}</span>
			</div>
			<div className="fixture-section-list">
				{items.map((f, i) => (
					<PremFixtureRow key={`${f.homeTeam}-${f.awayTeam}-${i}`} fixture={f} />
				))}
			</div>
		</section>
	);
};

export const FixturesScreen = () => {
	const api = useApi();
	const { loading, loadingMessage, error, fixtures } = usePremFixtures(api);
	const { week, maxWeekId } = useGameweekContext();
	const groups = groupFixtures(fixtures);

	return (
		<>
			<PageHeader
				title="Premier League"
				subtitle={week && maxWeekId ? `Gameweek ${maxWeekId} · Fixtures & scorers` : "Fixtures & scorers"}
				aside={groups.live.length > 0 ? <LiveBadge matchesLive={groups.live.length} /> : undefined}
			/>
			<Loader loading={loading} loadingMessage={loadingMessage} />
			{error && (
				<>
					<p className="error-message">{error}</p>
					<OriginHint />
				</>
			)}
			{!loading && !error && (
				<>
					<Section label="Live" items={groups.live} />
					<Section label="Finished" items={groups.finished} />
					<Section label="Upcoming" items={groups.upcoming} />
				</>
			)}
		</>
	);
};
